import {ChartData, ChartOptions} from 'chart.js';
import React from 'react';
import {HourTotalType} from 'src/app/information/kpis/store/types/chart-types';
import styled from 'styled-components';
//import {HorizontalBar} from 'react-chartjs-2';
import {Bar} from 'react-chartjs-2';
import 'chartjs-plugin-datalabels';
import {customFormatNumber} from 'src/shared/functions/FormatHelpers';
import {Spinner} from 'src/app/global/spinner';
//const initialState = {chart};

const Heading = styled.div<{fontSize?: number}>`
    display: flex;
    flex-direction: column;
    margin: 0px 4px;
    span {
        text-align: center;
    }
    & > span:nth-child(1) {
        text-transform: uppercase;
        font-weight: bold;
        font-size: ${({fontSize}) => fontSize || '1.7'}rem;
    }
`;

const chart: ChartData = {
    labels: [],
    datasets: [],
};

/***
 * CHART OPTIONS
 */
const options: ChartOptions = {
    legend: {
        display: true,
        position: 'top',
    },
    responsive: true,
    title: {
        display: false,
        text: 'Tendencia de palés/hora',
    },
    tooltips: {
        mode: 'nearest',
        intersect: false,
        callbacks: {
            label: (tooltipItem: any) => {
                return tooltipItem && tooltipItem.yLabel ? customFormatNumber(Number(tooltipItem.yLabel)) : '';
            },
        },
    },
    maintainAspectRatio: false,
    hover: {
        mode: 'nearest',
        intersect: true,
    },
    scales: {
        yAxes: [
            {
                display: true,
                scaleLabel: {
                    display: true,
                },
                ticks: {
                    beginAtZero: true,
                    callback(value: string) {
                        return customFormatNumber(Number(value));
                    },
                },
            },
        ],
    },
    plugins: {
        datalabels: {
            formatter: (value: any) => {
                return customFormatNumber(value);
            },
        },
    },
};

const initialState = {chart, options};

type State = {
    chart: ChartData;
    options: ChartOptions;
};

type Props = {
    chartData: HourTotalType;
    isLoading: boolean;
};

export class HourTotalDowntimeChart extends React.Component<Props, State> {
    readonly state = initialState;
    static getDerivedStateFromProps(props: Props) {
        let dataInfo: number[] = [];
        let labelInfo: string[] = [];

        if (props.chartData.hourByTasksValues && props.chartData.hourByTasksValues.length > 0) {
            dataInfo = props.chartData.hourByTasksValues;
            labelInfo = props.chartData.hourByTasksLabels;
        }

        const datasets = [
            {
                label: 'Horas',
                backgroundColor: '#99ff99',
                data: dataInfo,
                fill: false,
            },
        ] as any;

        const chartShow = {
            labels: labelInfo,
            datasets,
        };

        return {
            chart: chartShow,
        };
    }

    //readonly state = initialState;
    render() {
        if (this.props.isLoading) {
            return <Spinner isLoading={this.props.isLoading} position={'relative'} />;
        }

        if (this.props.chartData.hourProduccion) {
            return (
                <>
                    <Heading>
                        <span>{customFormatNumber(Number(this.props.chartData.hourProduccion))} Horas</span>
                    </Heading>
                    <Bar data={this.state.chart} options={this.state.options} />
                </>
            );
        } else {
            return (
                <Heading>
                    <span>-</span>
                </Heading>
            );
        }
    }
}
